export class SifremiUnuttumResponseModel {
    message:string
    result:boolean
}
